import { h } from 'preact'; /** @jsx h */
import { forwardRef } from 'preact/compat';

import './InputField.scss';

const InputField = forwardRef(
    ({ label, value, onChange, errorMessage, name, type = 'text', ...props }, ref) => (
        <div
            className={`input-container ${type === 'checkbox' && 'checkbox'} ${
                errorMessage && 'error-container'
            }`}
        >
            <input
                ref={ref}
                type={type}
                id={name}
                name={name}
                placeholder=" "
                value={value}
                onChange={onChange}
                {...props}
            />
            <label
                htmlFor={name}
                className={`${type === 'checkbox' ? 'checkbox-label' : 'normal-label'}`}
            >
                {label}
            </label>
            {errorMessage && <p className="input-error">{errorMessage}</p>}
        </div>
    )
);

export default InputField;
